import { useEffect, useState } from 'react';
import { useGlobalStore } from './use_global_context';

export const useUserAuthenticatedAndSettingsLoaded = (): boolean => {
    const { authStore, companySettingsStore, sdkStore, noteTemplatesStore } = useGlobalStore();

    const [useUserAuthenticatedAndSettingsLoaded, setUseUserAuthenticatedAndSettingsLoaded] =
        useState(false);

    const userSession = sdkStore.userSession.current;

    useEffect(() => {
        if (
            authStore.isUserSignedIn &&
            authStore.acceptedLatestTCs &&
            companySettingsStore.complete &&
            !!userSession &&
            noteTemplatesStore.complete
        ) {
            setUseUserAuthenticatedAndSettingsLoaded(true);
        }
    }, [
        authStore.isUserSignedIn,
        authStore.acceptedLatestTCs,
        companySettingsStore.complete,
        noteTemplatesStore.complete,
        userSession,
    ]);

    return useUserAuthenticatedAndSettingsLoaded;
};
